export default __webpack_public_path__ + "static/media/pickup.ffa72699.13c0e9d1.svg";